import {
  createContext,
  useContext,
  useMemo,
  type PropsWithChildren,
} from "react";
import { PolicyWithAgencyDataFragment } from "@covertree/agent-portal-graphql";

interface PolicyDetailsContextType {
  refetchPolicy?: () => void;
  policy?: PolicyWithAgencyDataFragment;
  loading: boolean;
  error: boolean;
}

interface PolicyDetailsProviderProps
  extends PropsWithChildren,
    PolicyDetailsContextType {}

export const PolicyDetailsContext = createContext<
  PolicyDetailsContextType | undefined
>(undefined);

export const usePolicyDetails = () => useContext(PolicyDetailsContext);

export function PolicyDetailsProvider({
  children,
  refetchPolicy,
  policy,
  loading,
  error,
}: PolicyDetailsProviderProps) {
  const value = useMemo(
    () => ({ refetchPolicy, policy, loading, error }),
    [refetchPolicy, policy, loading, error]
  );

  return (
    <PolicyDetailsContext.Provider value={value}>
      {children}
    </PolicyDetailsContext.Provider>
  );
}
